import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import mixpanel from 'mixpanel-browser';
import { colors, contentBlockShadow } from '../../../../theme';

const AVATAR = '/hub/checklist/fig_avatar.png';

const DEFAULT_TITLE = 'Keep the support going';
const DEFAULT_BODY = 'As your pet settles in, our trainers can help with training, behavior, routines, and common '
  + 'adjustment challenges. Upgrade to continue chatting with trainers and receiving personalized support.';

/**
 * Hero card for the expired-membership state, and (with the congratulations
 * title/body) the all-tasks-complete state.
 */
function MembershipUpsell({ title, body }: { title?: string; body?: string }) {
  const open = () => {
    mixpanel.track('extend_membership_click', { from_where: 'home' }, () => {
      window.open('https://petcademy.org/pricing/?utm_source=hub&utm_medium=checklist', '_blank', 'noopener');
    });
  };

  return (
    <Box
      sx={{
        bgcolor: '#fff',
        borderRadius: '12px',
        boxShadow: contentBlockShadow,
        p: { xs: 2.5, lg: '24px 28px' },
        display: 'flex',
        flexDirection: { xs: 'column', lg: 'row' },
        gap: { xs: 2, lg: 3 },
        alignItems: { xs: 'stretch', lg: 'center' },
      }}
    >
      <Box sx={{
        display: 'flex',
        flexDirection: { xs: 'column', lg: 'row' },
        alignItems: 'center',
        textAlign: { xs: 'center', lg: 'left' },
        gap: { xs: 1.75, lg: 2.75 },
        flex: 1,
        minWidth: 0,
      }}
      >
        <Box
          component="img"
          src={AVATAR}
          alt=""
          sx={{
            width: { xs: 72, lg: 84 },
            height: { xs: 72, lg: 84 },
            borderRadius: '50%',
            flexShrink: 0,
            objectFit: 'cover',
            bgcolor: colors.secondary[50],
          }}
        />
        <Box sx={{ minWidth: 0, width: { xs: '100%', lg: 'auto' } }}>
          <Typography sx={{ fontWeight: 700, fontSize: { xs: 19, lg: 22 }, lineHeight: 1.2 }}>
            {title || DEFAULT_TITLE}
          </Typography>
          <Typography sx={{
            fontSize: { xs: 13.5, lg: 14.5 }, color: 'text.secondary', mt: 0.75, lineHeight: 1.5, maxWidth: 520, mx: { xs: 'auto', lg: 0 },
          }}
          >
            {body || DEFAULT_BODY}
          </Typography>
          <Box sx={{ mt: 2, display: { xs: 'block', lg: 'none' } }}>
            <Button variant="contained" onClick={open}>Upgrade Membership</Button>
          </Box>
        </Box>
      </Box>
      <Button
        variant="contained"
        onClick={open}
        sx={{
          display: { xs: 'none', lg: 'inline-flex' }, flexShrink: 0, width: 'auto', px: 3, py: 1.375, fontSize: 15,
        }}
      >
        Upgrade Membership
      </Button>
    </Box>
  );
}

export default MembershipUpsell;
